import FingerprintJS from '@fingerprintjs/fingerprintjs'

import Supports from "../utils/supports";

let __isLookingUpDeviceFingerprint__ = false;
let __cachedFingerprint__ = null;
let __ipAddress__ = null;
const CACHE_TIME_LIMIT = 48 * 60 * 60 * 1000;

async function __getDeviceFingerprint__() {
    if (__cachedFingerprint__) return Promise.resolve(__cachedFingerprint__);
    if (__isLookingUpDeviceFingerprint__) return Promise.resolve(null);
    __isLookingUpDeviceFingerprint__ = true;

    try {
        const __cachedVisitorData__ = Supports.localStorage ? JSON.parse(localStorage.getItem('fp_visitor_data')) : null;
        if (__cachedVisitorData__ && Date.now() - __cachedVisitorData__.timestamp <= CACHE_TIME_LIMIT) {
            __cachedFingerprint__ = __cachedVisitorData__.visitorId;
            return __cachedFingerprint__;
        }

        const fpPromise = await FingerprintJS.load({ monitoring: false }); 
        const result = await fpPromise.get();
        const components = result.components;

        const enhancedData = {
            visitorId: result.visitorId,
            ipAddress: __ipAddress__ || '',
            canvas: components.canvas?.value || '',
            webglVendor: components.webGlBasics?.value?.vendor || '',
            webglRenderer: components.webGlBasics?.value?.renderer || '',
            audio: components.audio?.value || '',
            screenResolution: components.screenResolution?.value?.join('x') || '',
            colorDepth: components.colorDepth?.value || '',
            timezone: components.timezone?.value || '',
            hardwareConcurrency: components.hardwareConcurrency?.value || '',
            deviceMemory: components.deviceMemory?.value || '',
            platform: components.platform?.value || '',
            fonts: Array.isArray(components.fonts?.value) ? components.fonts.value.slice(0, 10).join(',') : '',
            touchSupport: JSON.stringify(components.touchSupport?.value || {}),
            hdr: components.hdr?.value || false,
            math: JSON.stringify(components.math?.value || {})
        };

        const enhancedFingerprint = await __hashEnhancedData__(enhancedData);

        // Cache in memory + localStorage
        __cachedFingerprint__ = enhancedFingerprint;

        localStorage.setItem('fp_visitor_data', JSON.stringify({
            visitorId: enhancedFingerprint,
            confidenceScore: result.confidence.score,
            timestamp: Date.now()
        }));

        return enhancedFingerprint;
    } catch (error) {
        console.error('Fingerprint generation error:', error);
        return null;
    } finally {
        __isLookingUpDeviceFingerprint__ = false;
    }
}

async function __hashEnhancedData__(data) {
    const dataString = Object.values(data).join('|');
    if (window.crypto?.subtle) {
        try {
            const encoder = new TextEncoder();
            const dataBuffer = encoder.encode(dataString);
            const hashBuffer = await window.crypto.subtle.digest('SHA-256', dataBuffer);
            return Array.from(new Uint8Array(hashBuffer)).map(b => b.toString(16).padStart(2, '0')).join('');
        } catch {}
    }
    // Fallback hash
    let hash = 5381;
    for (let i = 0; i < dataString.length; i++) {
        hash = ((hash << 5) + hash) + dataString.charCodeAt(i);
    }
    return Math.abs(hash).toString(16) + '-' + data.visitorId;
}

function __setIpAddress__(ip) {
    if (ip && typeof ip === 'string') {
        __ipAddress__ = ip;
        __cachedFingerprint__ = null;
    }
}

function __clearFingerprintCache__() {
    __cachedFingerprint__ = null;
    localStorage.removeItem('fp_visitor_data');
}

export {
    __getDeviceFingerprint__ as getFingerprintId,
    __setIpAddress__ as setFingerprintIp,
    __clearFingerprintCache__ as clearFingerprintCache
};
